import { ReactNode } from "react";

import BadgeNext from "../BadgeNext";
import Typography from "../Typography";
import Box from "../Box";

type FullScreenModalBodyHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  titleId?: string;
  noMargin?: boolean;
  isBeta?: boolean;
};

const FullScreenModalBodyHeader = ({
  title,
  description,
  titleId,
  noMargin = false,
  isBeta = false,
}: FullScreenModalBodyHeaderProps) => {
  return (
    <Box
      direction="column"
      align="center"
      gap="small"
      margin={noMargin ? undefined : "0 0 x-large 0"}
    >
      <Box direction="row" align="center" gap="small">
        <Typography tag="h2" variant="p-t6" align="center" id={titleId}>
          {title}
        </Typography>
        {isBeta && <BadgeNext variant="blue" text="BETA" type="strong" />}
      </Box>
      {description && (
        <Typography tag="p" variant="p-body3" align="center">
          {description}
        </Typography>
      )}
    </Box>
  );
};

FullScreenModalBodyHeader.displayName = "DS.FullScreenModal.BodyHeader";

export default FullScreenModalBodyHeader;
